import AppHeader, { AppWrapper } from "../../components/AppView";
import AppBody from "../AppBody";
import {
  TOKEN_ADDRESS,
  SIMPLESAWP_ADDRESS,
  USDT_ADDRESS,
  USERS_ADDRESS,
} from "../../constants/address";
import { useCallback, useEffect, useMemo, useState } from "react";
import useToken from "../../hooks/useToken";
import NumericalInput from "../../components/NumericalInput";
import TextInput from "../../components/TextInput";

import Row from "../../components/Row";
import { ButtonPrimary, ButtonLight } from "../../components/Button";

import { AutoColumn } from "../../components/Column";
import styled, { useTheme } from "styled-components";

import { Trans } from "@lingui/macro";

import usePkgUsers from "../../hooks/usePkgUsers";

import Loader from "../../components/Loader";
import { fromAmount, toAmount } from "../../utils/amount";
//import useERC20Allowance from '../../hooks/useERC20Allowance';
import { useWallet } from "use-wallet";
// import useERC20Approve from '../../hooks/useERC20Approve';
// import useERC20Balance from '../../hooks/useERC20Balance';
import Big from "big.js";
import { ZERO_ADDRESS } from "../../utils/ethereum";
import Modal from "../../components/Modal";
import { LoadingView, SubmittedView } from "../../components/ModalViews";
import PromoteBanner from "../../components/PromoteBanner";

const LabelWrapper = styled.div`
  font-size: 14px;
`;
const InputText = styled(TextInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;

const InputNumerical = styled(NumericalInput)`
  width: 100%;
  border-radius: 24px;
  padding: 8px 12px;
`;
const Symbol = styled.div`
  margin-left: 8px;
`;

const BalanceWrapper = styled.div`
  padding: 4px 2px;
  font-size: 14px;
`;

const ItemActionWrapper = styled.div`
  display: flex;
  margin-top: 12px;

  & > * {
    flex: 1;
    margin-right: 8px;
  }

  & > *:last-child {
    margin-right: unset;
  }
`;

function LockedConsole() {
  const {
    chainId,
    // account,
    // balance,
  } = useWallet();
  // const theme = useTheme();
  const {
    UpdatePkg,

  } = usePkgUsers(USERS_ADDRESS[chainId]);

  const [token] = useToken(TOKEN_ADDRESS[chainId]);
  //const [inputValue, setInputValue] = useState('');
  const [pkgid, setPkgid] = useState("");
  const [price, setPrice] = useState("");
  const [pkgdays, setPkgdays] = useState("");
  const [appgroup, setAppgroup] = useState("");
  const [daymaxcount, setDaymaxcount] = useState("");
  const [desc, setDesc] = useState("");
  const [outputValueEnough, setOutputValueEnough] = useState(true);

  const [loading, setLoading] = useState(false);
  const [isSubmitShow, setIsSubmitShow] = useState(false);
  const [submitHash, setSubmitHash] = useState("");
  const [submitError, setSubmitError] = useState("");

  const [withdrawloading, setWithdrawLoading] = useState(false); // 存款
  const [depositloading, setdepositloading] = useState(false); // 提现

  // 管理员提现
  const handleWithdraw = useCallback(async () => {
    const ethprice= fromAmount(price, token.decimals)
    const tx = await UpdatePkg([pkgid],[ethprice],[pkgdays],[[appgroup]],[daymaxcount],[desc],[ZERO_ADDRESS], setWithdrawLoading);
    setSubmitHash(tx.hash);
  
  }, [pkgid,price,pkgdays,appgroup,daymaxcount,desc,UpdatePkg]);



  return (
    <>
      <AppBody>
        <AppHeader>
          <Trans>Add Pkg</Trans>
        </AppHeader>
        <AppWrapper>
          <AutoColumn gap={"sm"}>
            <AutoColumn gap={"2px"}>
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>pkgid</Trans>
                </LabelWrapper>
                <Row>
                  <InputNumerical
                  placeholder="1"
                    value={pkgid}
                    onUserInput={setPkgid}
                  />
                </Row>
              </AutoColumn>
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>price</Trans>
                </LabelWrapper>
                <Row>
                  <InputNumerical
                    placeholder=" "
                    value={price}
                    onUserInput={setPrice}
                  />
                </Row>
              </AutoColumn>
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>pkgdays</Trans>
                </LabelWrapper>
                <Row>
                  <InputNumerical
                   placeholder="180"
                    value={pkgdays}
                    onUserInput={setPkgdays}
                  />
                </Row>
              </AutoColumn>
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>appgroup</Trans>
                </LabelWrapper>
                <Row>
                  <InputText
                    placeholder="GPT4"
                    value={appgroup}
                    onUserInput={setAppgroup}
                  />
                </Row>
              </AutoColumn>
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>daymaxcount</Trans>
                </LabelWrapper>
                <Row>
                  <InputNumerical
                   placeholder="10000"
                    value={daymaxcount}
                    onUserInput={setDaymaxcount}
                  />
                </Row>
              </AutoColumn>
              <AutoColumn gap={"sm"}>
                <LabelWrapper>
                  <Trans>desc</Trans>
                </LabelWrapper>
                <Row>
                  <InputText  placeholder=" "
                  value={desc} onUserInput={setDesc} />
                
                </Row>
              </AutoColumn>
            </AutoColumn>
            <ItemActionWrapper>
              <ButtonPrimary disabled={loading} onClick={handleWithdraw}>
                {!outputValueEnough ? (
                  <Trans>Not enough balance</Trans>
                ) : (
                  <Trans>AddPkg </Trans>
                )}
                {loading ? <Loader /> : null}
              </ButtonPrimary>


            </ItemActionWrapper>
          </AutoColumn>
        </AppWrapper>

        <Modal isOpen={isSubmitShow} onDismiss={() => setIsSubmitShow(false)}>
          {loading ? (
            <LoadingView onDismiss={() => setIsSubmitShow(false)} />
          ) : (
            <SubmittedView
              onDismiss={() => setIsSubmitShow(false)}
              hash={submitHash}
            >
              {submitError ? submitError : <Trans>Locked Succeeded.</Trans>}
            </SubmittedView>
          )}
        </Modal>
      </AppBody>
    </>
  );
}

export default LockedConsole;
